
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsExchangeRateDialog extends Serenity.EntityDialog<PsExchangeRateRow, any> {
        protected getFormKey() { return PsExchangeRateForm.formKey; }
        protected getIdProperty() { return PsExchangeRateRow.idProperty; }
        protected getLocalTextPrefix() { return PsExchangeRateRow.localTextPrefix; }
        protected getNameProperty() { return PsExchangeRateRow.nameProperty; }
        protected getService() { return PsExchangeRateService.baseUrl; }
        protected getDeletePermission() { return PsExchangeRateRow.deletePermission; }
        protected getInsertPermission() { return PsExchangeRateRow.insertPermission; }
        protected getUpdatePermission() { return PsExchangeRateRow.updatePermission; }

        protected form = new PsExchangeRateForm(this.idPrefix);

    }
}